export enum AMAZON_PAY_NB_STATES {
    IS_SDK_AVAILABLE = "IS_AMAZON_SDK_AVAILABLE",
    WAS_PREVIOUSLY_LINKED = "WAS_PREVIOUSLY_LINKED",
    GET_BALANCE = "GET_BALANCE",
    LINK_WALLET = "LINK_WALLET",
    LINK_WALLET_V2 = "LINK_WALLET_V2",
    GET_APAY_METADATA = "GET_APAY_METADATA",
    CHECK_CHARGE_STATUS = "CHECK_CHARGE_STATUS",
    PROCEED_TO_PAY = "PROCEED_TO_PAY",
    PROCEED_TO_PAY_V2 = "PROCEED_TO_PAY_V2",
}

export const AMAZON_PAY_CUSTOM_EVENTS = {
    PROCEED_TO_PAY_V2_EMPTY_PAY_URL: "PROCEED_TO_PAY_V2_EMPTY_PAY_URL",
};

export const AMAZON_PAY_STATE_STALE_REASONS = {
    LINKED_MISMATCH: "LINKED_MISMATCH",
    APL_LINKED_MISMATCH: "APL_LINKED_MISMATCH",
    BALANCE_MISMATCH: "BALANCE_MISMATCH",
    AVAILABILITY_MISMATCH: "AVAILABILITY_MISMATCH",
    BALANCE_SUFFICIENCY_STALE: "BALANCE_SUFFICIENCY_STALE",
    APL_CREDIT_LIMIT_MISMATCH: "APL_CREDIT_LIMIT_MISMATCH",
    APL_CREDIT_SUFFICIENCY_STALE: "APL_CREDIT_SUFFICIENCY_STALE",
};

export enum AMAZON_PAY_LINK_STATUS {
    GRANTED = "GRANTED",
    DENIED = "DENIED",
}

export enum APAY_NB_CALL_STATUS {
    SUCCESS = "success",
    FAILURE = "failure",
    TIMEOUT = "timeout",
}
